/**
 * @module UseExpandToggle
 * @description Phase 18 extraction of shared expand/collapse state for verify result rows.
 * Keeps single-expanded-row behavior reusable across verify result presentations.
 */

import { useState, useCallback } from 'react';

/**
 * Manage single-item expand/collapse toggle state.
 * Only one item can be expanded at a time — selecting a new item
 * collapses the previously expanded one.
 *
 * @param {*} [initialExpanded=null] - Initial expanded item identifier
 * @returns {{ expandedItem: *, toggleExpand: Function, isExpanded: Function }}
 */
export function useExpandToggle(initialExpanded = null) {
    const [expandedItem, setExpandedItem] = useState(initialExpanded);

    const toggleExpand = useCallback((itemId) => {
        setExpandedItem((prev) => (prev === itemId ? null : itemId));
    }, []);

    const isExpanded = useCallback((itemId) => expandedItem === itemId, [expandedItem]);

    return { expandedItem, toggleExpand, isExpanded };
}
